import { Row } from 'antd'
import CallToActionInfo from 'app/components/Core/PriceList/CallToActionInfo'
import DownloadButtons from 'app/components/Core/PriceList/DownloadButtons'
import PriceListEmpty from 'app/components/Core/PriceList/Empty'
import PriceListInfo from 'app/components/Core/PriceList/PriceListInfos'
import PriceListTables from 'app/components/Core/PriceList/PriceListRender'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { queries } from 'app/queries'
import * as React from 'react'

const PriceListIndex: React.FC<PageProps> = (props) => {
  const { titlelizer } = useTitle(props)
  const customer = useCurrentCustomer()
  const { data, loading } = useQuery<{ customerPriceList: IPriceList }>(queries.priceList.get)
  const priceList = data?.customerPriceList // either custom or global reference price list

  const hasCustomPriceList = priceList && customer?.has_price_list
  const titleId = hasCustomPriceList && `#${priceList?.id?.toString()}`

  const hasReferencePriceList = priceList && !customer?.has_price_list

  return (
    <Row>
      <KCol
        card
        title={titlelizer({ id: titleId })}
        span={24}
        loading={loading || !customer}
        cardProps={{ extra: hasCustomPriceList && <DownloadButtons /> }}>
        <Row gutter={[0, 24]}>
          <Choose>
            <When condition={hasCustomPriceList}>
              <KCol span={24}>
                <PriceListInfo priceList={priceList} />
              </KCol>
              <KCol span={24}>
                <PriceListTables priceList={priceList} />
              </KCol>
            </When>
            <When condition={hasReferencePriceList}>
              <KCol span={24}>
                <CallToActionInfo />
              </KCol>
              <KCol span={24}>
                <PriceListTables priceList={priceList} />
              </KCol>
            </When>
            <Otherwise>
              <KCol span={24} style={{ paddingTop: 70, paddingBottom: 120 }}>
                <PriceListEmpty />
              </KCol>
            </Otherwise>
          </Choose>
        </Row>
      </KCol>
    </Row>
  )
}

export default PriceListIndex
